<script setup>
const props = defineProps({
  data: Object,
  pulseData: Object
})

const { getRecShared } = useLeadGenRecData();
const { data: recSharedData } = await getRecShared();
const emit = defineEmits(['studentName', 'validateStep']);
const placeholderText = props.data.sharedContent ? recSharedData.value.data.attributes.studentName : props.data.placeholderText;
const errorText = props.data.sharedContent ? recSharedData.value.data.attributes.studentNameError : props.data.errorText;
const selectedName = ref(null);
const studentValue = toRef(props, 'pulseData');

const onFieldChanged = (field) => {
  selectedName.value = field.value;
  emit('studentName', selectedName.value);
  emit('validateStep', {
  value: selectedName.value,
  component: props.data.component
});
  studentValue.value.students[0].studentFirstName = selectedName.value;
};
const onKeyPress = (field) => {
  selectedName.value = field.value;
  emit('validateStep', {
  value: selectedName.value,
  component: props.data.component
});
}

onMounted(() => {
  const parentElement = document.getElementById('course-rec-name').parentElement.parentElement.parentElement
  
  const observer = new MutationObserver((mutationsList, observer) => {
    for (var mutation of mutationsList) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'style' && parentElement.style.display !== 'none') {
        emit('validateStep', {
  value: selectedName.value,
  component: props.data.component
});
      }
    }
  });
  observer.observe(parentElement, { attributes: true});
})
</script>

<template>
  <form id="course-rec-name" @submit.prevent>
    <fieldset>
      <div class="col mx-3">
        <FormFloatingLabelInput :id="'studentName'" :placeholderText="placeholderText" :errorText="errorText" :required="false"
        @onChanged="onFieldChanged" @onKeyPress="onKeyPress"/>
      </div>
    </fieldset>
  </form>
</template>

<style lang="scss">
#course-rec-name {
  .form-floating {
    @include media-breakpoint-up(sm) {
      width: 350px;
      margin: 0 auto;;
    }
  }
}
</style>